/** Content-type discriminators that represent a scheduled live session
 *  (in-class, Zoom meeting/webinar) rather than on-demand content. */
const LIVE_PLUGIN_IDS = new Set(['InClass', 'ZoomMeetings', 'ZoomWebinar']);

/** True when a course is a live-session type carrying a schedule at all
 *  — gates whether the card renders its "LIVE" mode (time range badge,
 *  join CTA), independent of whether the session is happening right now. */
export function isLiveCourse(c: { pluginId?: string; liveStartDate?: string }): boolean {
  return Boolean(c.pluginId && LIVE_PLUGIN_IDS.has(c.pluginId) && c.liveStartDate);
}

/** True when a live course's session window covers `now` — gates the
 *  "join now" state (pulsing badge, enabled join button) vs. the
 *  upcoming/scheduled state. */
export function isLiveNow(
  c: { liveStartDate?: string; liveEndDate?: string },
  now: Date = new Date(),
): boolean {
  if (!c.liveStartDate) return false;
  const start = new Date(c.liveStartDate).getTime();
  const end = c.liveEndDate ? new Date(c.liveEndDate).getTime() : start;
  const t = now.getTime();
  return t >= start && t <= end;
}
